//data-x-menu--depth

if (document.body.classList.contains('template-index')) {

  var arr = document.querySelectorAll("nav.x-menu li[data-x-menu--depth]");
  var f = function() {
    // do something
  };
  for (var i = 0; i < arr.length; i++) {
    //arr[i].onclick = f;
    console.log(arr[i].getAttribute("data-x-menu--depth"));
    if (arr[i].getAttribute("data-x-menu--depth") > 1) {
      arr[i].addEventListener("mouseenter", function( event ) {
        var header = document.getElementById("shopify-section-header");
        header.classList.add('white-bg');
      }, false);
      arr[i].addEventListener("mouseleave", function( event ) {
        var header = document.getElementById("shopify-section-header");
        header.classList.remove('white-bg');
      }, false);
    }
  }
  
}